/**
 * @generated SignedSource<<86159b4aa3cf79711fadec1214c9dbc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveWorkflowTemplateInput = {
  id: string;
};
export type useWorkflowTemplateArchiveMutation$variables = {
  input: ArchiveWorkflowTemplateInput;
};
export type useWorkflowTemplateArchiveMutation$data = {
  readonly archiveWorkflowTemplate: {
    readonly workflowTemplate: {
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type useWorkflowTemplateArchiveMutation = {
  variables: useWorkflowTemplateArchiveMutation$variables;
  response: useWorkflowTemplateArchiveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveWorkflowTemplatePayload",
    "kind": "LinkedField",
    "name": "archiveWorkflowTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowTemplate",
        "kind": "LinkedField",
        "name": "workflowTemplate",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkflowTemplateArchiveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWorkflowTemplateArchiveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "42c6d132e19e45ee87c2e36d61a2265b",
    "id": null,
    "metadata": {},
    "name": "useWorkflowTemplateArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkflowTemplateArchiveMutation(\n  $input: ArchiveWorkflowTemplateInput!\n) {\n  archiveWorkflowTemplate(input: $input) {\n    workflowTemplate {\n      id\n      organization {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c9277dbd2def9d38386f6c5d6c7baf6";

export default node;
